import { defaultDataTransformer } from '@aspectus/resource-commons';
import { createReceiver, createSender } from '@md/resources';
import { prefixAPI } from '@md/api';

const r = (tpl, f = createReceiver) => f(prefixAPI(tpl)).transform(defaultDataTransformer);

export const ratingReviews = {
  listOfQuestions: r('/rating-reviews/questions/list/'),
  finish: r('/rating-reviews/finish/', createSender),
  cancel: r('/rating-reviews/cancel/', createSender),
};
